module.exports = __webpack_public_path__ + "assets/66ff0185df08b968ce58ff4e96c6b6af.png";